import React from "react";
import "./InvoiceFeatures.scss";
import DocumentIcon from "../../assets/images/document-icon.png";
import BagIcon from "../../assets/images/bag-icon.png";
import DownloadIcon from "../../assets/images/download-icon.png";
import { FileFilled } from "@ant-design/icons";

const GSTInvoiceFeatures: React.FC = () => {
  return (
    <div className="invoice-feature-container">
      <p className="gst-invoice-info">
        GST tax invoices will be processed using the GSTIN you provided during
        booking.
      </p>
      <div className="feature-cards">
        <div className="feature-card">
          <div className="icon document-icon">
            <FileFilled
              style={{
                color: "#74003B",
                height: "40px",
                fontSize: "22px",
                marginLeft: "8px",
              }}
            />
          </div>
          <h3>Download your GST Invoice</h3>
          <p>Download Tax Invoices for travel and cargo</p>
        </div>
        <div className="feature-card">
          <div className="icon bag-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="35"
              height="35"
              style={{
                marginLeft: "7px",
                width: "25px",
                height: "25px",
                marginTop: "7px",
              }}
              viewBox="0 0 20 21"
              fill="none"
            >
              <path
                d="M16.8375 15.9109C16.8782 16.0226 16.8861 16.1437 16.8604 16.2598C16.8346 16.3759 16.7763 16.4822 16.6922 16.5663L14.8172 18.4413C14.7592 18.4995 14.6903 18.5456 14.6144 18.5771C14.5385 18.6086 14.4572 18.6249 14.375 18.6249C14.3545 18.6261 14.3339 18.6261 14.3133 18.6249C14.2213 18.6159 14.1324 18.5865 14.0531 18.5389C13.9738 18.4914 13.9061 18.4268 13.8547 18.3499L10.4118 13.1843L8.75004 14.8429V16.7499C8.74996 16.9155 8.68421 17.0742 8.56722 17.1913C8.56722 17.1913 7.47347 18.2898 7.3266 18.4319C7.26554 18.4959 7.19148 18.546 7.10941 18.5788C6.95645 18.6411 6.78505 18.6404 6.63266 18.5767C6.48027 18.513 6.35928 18.3916 6.29613 18.239L6.29144 18.2273L5.14301 15.3554L2.26566 14.2046C2.16968 14.1662 2.08471 14.1046 2.01839 14.0253C1.95206 13.946 1.90644 13.8515 1.88561 13.7502C1.86479 13.649 1.86941 13.5441 1.89906 13.4451C1.92871 13.346 1.98246 13.2559 2.05551 13.1827L3.30551 11.9327C3.36387 11.8744 3.4332 11.8283 3.50949 11.7969C3.58579 11.7655 3.66754 11.7495 3.75004 11.7499H5.65629L7.31801 10.0882L2.15316 6.64445C2.07613 6.59317 2.01144 6.52542 1.96378 6.4461C1.91611 6.36678 1.88666 6.27786 1.87754 6.18577C1.86842 6.09368 1.87987 6.00072 1.91105 5.91359C1.94223 5.82646 1.99237 5.74734 2.05785 5.68195L3.93285 3.80695C4.01696 3.72288 4.12331 3.66455 4.23942 3.63881C4.35552 3.61307 4.47656 3.62099 4.58832 3.66164L11.3024 6.10304L13.7657 3.63976C14.1759 3.2295 14.7323 2.99902 15.3125 2.99902C15.5998 2.99902 15.8843 3.05561 16.1497 3.16555C16.4151 3.27548 16.6563 3.43662 16.8594 3.63976C17.0626 3.8429 17.2237 4.08406 17.3336 4.34947C17.4436 4.61489 17.5001 4.89935 17.5001 5.18664C17.5001 5.47392 17.4436 5.75838 17.3336 6.0238C17.2237 6.28921 17.0626 6.53037 16.8594 6.73351L14.3961 9.19679L16.8375 15.9109Z"
                fill="#74003B"
              />
            </svg>
          </div>
          <h3>Upload Travel details</h3>
          <p>Ensure correct GST details get captured & no loss of GST Credit</p>
        </div>
        <div className="feature-card">
          <div className="icon download-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="21"
              style={{
                marginLeft: "7px",
                width: "25px",
                height: "25px",
                marginTop: "7px",
              }}
              viewBox="0 0 20 21"
              fill="none"
            >
              <path
                d="M5.80781 7.19219C5.69054 7.07491 5.62465 6.91585 5.62465 6.75C5.62465 6.58415 5.69054 6.42509 5.80781 6.30781C5.92509 6.19054 6.08415 6.12465 6.25 6.12465C6.41585 6.12465 6.57491 6.19054 6.69219 6.30781L9.375 8.99141V2.375C9.375 2.20924 9.44085 2.05027 9.55806 1.93306C9.67527 1.81585 9.83424 1.75 10 1.75C10.1658 1.75 10.3247 1.81585 10.4419 1.93306C10.5592 2.05027 10.625 2.20924 10.625 2.375V8.99141L13.3078 6.30781C13.4251 6.19054 13.5841 6.12465 13.75 6.12465C13.9159 6.12465 14.0749 6.19054 14.1922 6.30781C14.3095 6.42509 14.3753 6.58415 14.3753 6.75C14.3753 6.91585 14.3095 7.07491 14.1922 7.19219L10.4422 10.9422C10.3841 11.0003 10.3152 11.0464 10.2393 11.0779C10.1635 11.1093 10.0821 11.1255 10 11.1255C9.91787 11.1255 9.83654 11.1093 9.76066 11.0779C9.68479 11.0464 9.61586 11.0003 9.55781 10.9422L5.80781 7.19219ZM18.75 11.125V16.125C18.75 16.4565 18.6183 16.7745 18.3839 17.0089C18.1495 17.2433 17.8315 17.375 17.5 17.375H2.5C2.16848 17.375 1.85054 17.2433 1.61612 17.0089C1.3817 16.7745 1.25 16.4565 1.25 16.125V11.125C1.25 10.7935 1.3817 10.4755 1.61612 10.2411C1.85054 10.0067 2.16848 9.875 2.5 9.875H6.59375C6.6348 9.87497 6.67545 9.88302 6.71339 9.89871C6.75133 9.91439 6.7858 9.9374 6.81484 9.96641L8.67188 11.8281C8.84607 12.0029 9.05306 12.1416 9.28097 12.2363C9.50887 12.3309 9.75322 12.3796 10 12.3796C10.2468 12.3796 10.4911 12.3309 10.719 12.2363C10.9469 12.1416 11.1539 12.0029 11.3281 11.8281L13.1875 9.96875C13.2452 9.90987 13.3238 9.87617 13.4062 9.875H17.5C17.8315 9.875 18.1495 10.0067 18.3839 10.2411C18.6183 10.4755 18.75 10.7935 18.75 11.125ZM15.625 13.625C15.625 13.4396 15.57 13.2583 15.467 13.1042C15.364 12.95 15.2176 12.8298 15.0463 12.7589C14.875 12.6879 14.6865 12.6693 14.5046 12.7055C14.3227 12.7417 14.1557 12.831 14.0246 12.9621C13.8935 13.0932 13.8042 13.2602 13.768 13.4421C13.7318 13.624 13.7504 13.8125 13.8214 13.9838C13.8923 14.1551 14.0125 14.3015 14.1667 14.4045C14.3208 14.5075 14.5021 14.5625 14.6875 14.5625C14.9361 14.5625 15.1746 14.4637 15.3504 14.2879C15.5262 14.1121 15.625 13.8736 15.625 13.625Z"
                fill="#74003B"
              />
            </svg>
          </div>
          <h3>Download Reprots</h3>
          <p>Download various reports</p>
        </div>
      </div>
    </div>
  );
};

export default GSTInvoiceFeatures;
